import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { installErrorReporter } from './lib/errorReporter';
import './styles/index.css';

installErrorReporter();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Service Worker: מאפשר התקנה למסך הבית ועבודה עם קליטה חלשה. מתעדכן אוטומטית.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  registerSW({ immediate: true });
}
